<template>
  <div>
    <v-card outlined elevation="0" class="rounded-lg ma-4" tile>
      <v-sheet :class="showAllowedProducts ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="py-2 card-title-height">
          <v-btn icon @click="card()">
            <v-icon color="white">
              {{
                showAllowedProducts ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <span class="text-body-1 white--text">Affectation de Produits</span>
          <v-spacer />
          <v-select
            v-model="selectedWorkspace"
            item-text="label"
            item-value="code"
            :items="workspaces"
            label="Choisir le centre"
            outlined
            hide-details
            dense
            flat
            solo
            style="max-width: 400px"
            return-object
          />
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showAllowedProducts" class="grey lighten-4">
          <v-divider />
          <div class="d-flex justify-center">
            <v-row>
              <v-col class="flex-auto">
                <ProductList
                  :products="sortedAllowedList"
                  title="Produit(s) affecté(s) au client"
                  drop-element="limitedProducts"
                  selected="allowed"
                  :update-customer-product="updateCustomerProduct"
                  :update-selected-products="updateSelectedProducts"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="1" class="text-center d-flex align-center justify-center">
                <v-icon :disabled="loading" size="36" color="black" @click="swapProducts"> mdi-code-tags </v-icon>
              </v-col>
              <v-col class="flex-auto">
                <ProductList
                  :products="sortedLimitedList"
                  title="Produit que l'on peut affecter au client"
                  drop-element="allowedProducts"
                  selected="limited"
                  :update-customer-product="updateCustomerProduct"
                  :update-selected-products="updateSelectedProducts"
                  :disabled="loading"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>

import { EventBus } from '../../mixins';
import { requests } from '@/mixins';
import ProductList from './allowedProducts/ProductList.vue';

export default {
  components: { ProductList },
  mixins: [requests],
  props: { customer: Object },
  data () {
    return {
      showAllowedProducts: true,
      selectedWorkspace: null,
      products: [],
      loading: false,
      participantProducts: {
        allowedProducts: [],
        limitedProducts: [],
        selectedProducts: {
          allowed: [],
          limited: []
        }
      }
    };
  },
  computed: {
    workspaces () {
      return this.$store.state.alphaWorkspaces;
    },
    sortedAllowedList () {
      return this.sortArray(this.participantProducts.allowedProducts, 'name');
    },
    sortedLimitedList () {
      return this.sortArray(this.participantProducts.limitedProducts, 'name');
    }
  },
  watch: {
    async selectedWorkspace (newVal) {
      this.changeLoading(true);
      await this.limitedProducts();
      this.populateParticipantsProduct();
      this.changeLoading(false);
    },
    customer () {
      this.populateParticipantsProduct();
    }
  },
  mounted () {
    this.changeLoading(true);
    this.populateParticipantsProduct();
    this.changeLoading(false);
  },
  methods: {
    sortArray (array, field, operation = '<') {
      return (array || []).sort((a, b) => (eval(` ("${a[field]}" ${operation} "${b[field]}" )`) ? -1 : 1));
    },
    populateParticipantsProduct () {
      if (this.selectedWorkspace) {
        this.participantProducts.limitedProducts = [];
        this.participantProducts.allowedProducts = [];

        if (this.$props.customer && this.$props.customer.allowed_products) {
          const allowed = [];
          this.$props.customer.allowed_products.forEach(p => {
            const product = this.products.find(prod => prod.uuid === p.product_uuid);
            if (product) {
              allowed.push(product);
            }
          });
          this.participantProducts.allowedProducts = allowed;
          this.participantProducts.limitedProducts = this.products.filter(p => !this.$props.customer.allowed_products.find(ap => ap.product_uuid === p.uuid));

          return;
        }

        this.participantProducts.limitedProducts = this.products;
      }
    },
    changeLoading (value) {
      this.loading = value;
    },
    card () {
      this.showAllowedProducts = !this.showAllowedProducts;
    },
    async limitedProducts () {
      const response = this.selectedWorkspace.isPegase ? await this.getAlphaProducts(this.selectedWorkspace.code) : await this.getLimitedProducts(this.selectedWorkspace.code);

      if (response.success) {
        this.products = response.data.items.map(i => ({
          ...i,
          isSelected: false
        }));
      }
    },
    async updateAllowedProduct () {
      this.changeLoading(true);
      const customerToUpdate = { ...this.$props.customer };

      customerToUpdate.allowed_products = this.participantProducts.allowedProducts.map(p => ({
        product_uuid: p.uuid,
        horanet_product_code: null,
        product_name: p.name
      }));

      // Preserve allowed products from other workspaces (not in current workspace's product list)
      (this.$props.customer.allowed_products || []).forEach(ap => {
        if (!this.products.some(p => p.uuid === ap.product_uuid)) {
          customerToUpdate.allowed_products.push(ap);
        }
      });

      const response = await this.updateCustomerAllowedProduct(customerToUpdate.uuid, customerToUpdate.allowed_products, this.selectedWorkspace.code);

      if (response.success) {
        EventBus.$emit('show-notifications', [{
          message: 'Client mis à jour avec succès',
          type: 'success'
        }]);
        this.changeLoading(false);
        return;
      }
      EventBus.$emit('show-notifications', [{
        message: 'Erreur lors de la mise à jour du client',
        type: 'danger'
      }]);
      this.changeLoading(false);
    },
    swapProducts () {
      let indexToRemove = [];
      this.participantProducts.selectedProducts.allowed.forEach(p => {
        this.participantProducts.limitedProducts.push(p);

        const index = this.participantProducts.allowedProducts.findIndex(ap => ap.uuid === p.uuid);
        if (index !== -1) {
          indexToRemove.push(index);
        }
      });

      indexToRemove = indexToRemove.sort((a, b) => (a < b ? -1 : 1));

      for (let i = indexToRemove.length - 1; i >= 0; i -= 1) {
        this.participantProducts.allowedProducts.splice(indexToRemove[i], 1);
      }

      indexToRemove = [];

      this.participantProducts.selectedProducts.limited.forEach(p => {
        this.participantProducts.allowedProducts.push(p);

        const index = this.participantProducts.limitedProducts.findIndex(ap => ap.uuid === p.uuid);
        if (index !== -1) {
          indexToRemove.push(index);
        }
      });

      indexToRemove = indexToRemove.sort((a, b) => (a < b ? -1 : 1));

      for (let i = indexToRemove.length - 1; i >= 0; i -= 1) {
        this.participantProducts.limitedProducts.splice(indexToRemove[i], 1);
      }

      this.participantProducts.selectedProducts = {
        allowed: [],
        limited: []
      };

      // update Customer
      this.updateAllowedProduct();
    },
    updateCustomerProduct (product_uuid, elementType) {
      const product = this.products.find(p => p.uuid === product_uuid);
      this.participantProducts[elementType].push(product);

      const elementToRemove = elementType === 'limitedProducts' ? 'allowedProducts' : 'limitedProducts';

      const index = this.participantProducts[elementToRemove].findIndex(p => p.uuid === product_uuid);

      if (index !== -1) {
        this.participantProducts[elementToRemove].splice(index, 1);
      }

      // update costumer
      this.updateAllowedProduct();
    },
    updateSelectedProducts (typeToUpdate, product, action) {
      if (action === 'add') {
        this.participantProducts.selectedProducts[typeToUpdate].push(product);
        return;
      }
      const index = this.participantProducts.selectedProducts[typeToUpdate].findIndex(p => p.uuid === product.uuid);

      if (index !== -1) {
        this.participantProducts.selectedProducts[typeToUpdate].splice(index, 1);
      }
    }
  }
};
</script>
